/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} EnglishInputs */

const en_english = /** @type {(inputs: EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const fr_english = /** @type {(inputs: EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const de_english = /** @type {(inputs: EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Englisch`)
};

const it_english = /** @type {(inputs: EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglese`)
};

const ru_english = /** @type {(inputs: EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Английский`)
};

const es_english = /** @type {(inputs: EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglés`)
};

const zh_cn2_english = /** @type {(inputs: EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`英语`)
};

const ja_english = /** @type {(inputs: EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`英語`)
};

const hi_english = /** @type {(inputs: EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंग्रेज़ी`)
};

const pt_pt2_english = /** @type {(inputs: EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglês`)
};

/**
* | output |
* | --- |
* | "English" |
*
* @param {EnglishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const english = /** @type {((inputs?: EnglishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<EnglishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_english(inputs)
	if (locale === "de") return de_english(inputs)
	if (locale === "it") return it_english(inputs)
	if (locale === "ru") return ru_english(inputs)
	if (locale === "es") return es_english(inputs)
	if (locale === "zh-CN") return zh_cn2_english(inputs)
	if (locale === "ja") return ja_english(inputs)
	if (locale === "hi") return hi_english(inputs)
	if (locale === "pt-PT") return pt_pt2_english(inputs)
	return en_english(inputs)
});